module.exports = __webpack_public_path__ + "img/9788983925008.18a5e389.jpg";